export default __webpack_public_path__ + "static/media/application-screenshot.dacf9e77.png";